import { Tooltip } from 'antd';
import { Question } from '@styled-icons/remix-line';
import theme from 'styles/theme';

import * as S from './styles';

export type ChartLegendProps = {
  title: string;
  firstText: string;
  secondText: string;
  tooltip: string;
  color: string;
};

const ChartLegend = ({
  title,
  firstText,
  secondText,
  tooltip,
  color,
}: ChartLegendProps) => {
  return (
    <S.Wrapper>
      <S.Indicator color={color} />
      <S.LegendWrapper>
        <S.Text color="neutralSilver90">{title}</S.Text>
        <S.Text color="neutralSilver60">{firstText}</S.Text>
        <S.TooltipContainer>
          <S.Text color="neutralSilver70">{secondText}</S.Text>
          <Tooltip title={tooltip}>
            <Question size={20} color={theme.colors.neutralSilver50} />
          </Tooltip>
        </S.TooltipContainer>
      </S.LegendWrapper>
    </S.Wrapper>
  );
};

export default ChartLegend;
